"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _sourceFileHelper = require("../../utils/sourceFileHelper");
var _SourceItems = require("../../constants/SourceItems");
var _TemplateChooser = require("./TemplateChooser.styled");
var _useElementInViewport = require("../../hooks/useElementInViewport/useElementInViewport");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function TemplateItem(_ref) {
  var item = _ref.item,
    handleChange = _ref.handleChange,
    index = _ref.index,
    title = _ref.title,
    containerElementSelector = _ref.containerElementSelector,
    isSelected = _ref.isSelected;
  var key = item.key,
    name = item.name,
    _id = item._id;
  var eventDocRef = key || _id || name;
  var fileType = (0, _sourceFileHelper.getFileSourceType)(name || key);
  var isValidTemplateSourceType = _SourceItems.templateSourceTypes.has(fileType);
  var elementRef = (0, _react.useRef)(null);
  var isInView = (0, _useElementInViewport.useElementInViewport)({
    elementRef: elementRef,
    containerElementSelector: containerElementSelector
  });
  var renderMediaItem = function renderMediaItem(_ref2, index, mediaTitle) {
    var url = _ref2.url,
      key = _ref2.key;
    var mediaTemplateId = "media-template-id-".concat(index);
    switch (fileType) {
      case _SourceItems.IMAGE_FILE:
        return /*#__PURE__*/_react["default"].createElement(_TemplateChooser.StyledTemplateMedia, null, /*#__PURE__*/_react["default"].createElement("img", {
          src: url,
          alt: mediaTitle,
          id: mediaTemplateId
        }));
      case _SourceItems.VIDEO_FILE:
        return /*#__PURE__*/_react["default"].createElement(_TemplateChooser.StyledTemplateMedia, null, !key ? /*#__PURE__*/_react["default"].createElement("img", {
          src: url,
          alt: mediaTitle,
          id: mediaTemplateId
        }) : /*#__PURE__*/_react["default"].createElement("video", {
          src: url,
          alt: mediaTitle,
          id: mediaTemplateId
        }));
      case _SourceItems.AUDIO_FILE:
        return /*#__PURE__*/_react["default"].createElement(_TemplateChooser.StyledTemplateMedia, null, /*#__PURE__*/_react["default"].createElement("audio", {
          src: url,
          alt: mediaTitle,
          id: mediaTemplateId
        }));
      default:
        return null;
    }
  };
  return isValidTemplateSourceType && item.url && /*#__PURE__*/_react["default"].createElement(_TemplateChooser.StyledTemplateItem, {
    ref: elementRef,
    key: index,
    "data-testid": "template-".concat(eventDocRef, "-wrapper")
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "template-".concat(eventDocRef, "-radio-button"),
    className: "image-checkbox",
    title: eventDocRef
  }, /*#__PURE__*/_react["default"].createElement(_TemplateChooser.StyledRadioInput, {
    "data-testid": "template-".concat(index, "-radio-button"),
    type: "radio",
    name: "templateChooser",
    value: eventDocRef,
    onChange: handleChange,
    id: "template-".concat(eventDocRef, "-radio-button"),
    checked: isSelected
  }), isInView ? renderMediaItem(item, index, title) : /*#__PURE__*/_react["default"].createElement(_TemplateChooser.StyledTemplateMedia, {
    "data-testid": "default-media"
  })), /*#__PURE__*/_react["default"].createElement(_TemplateChooser.StyledMediaTitle, null, title));
}
TemplateItem.propTypes = {
  item: _propTypes["default"].shape({
    key: _propTypes["default"].string,
    name: _propTypes["default"].string,
    url: _propTypes["default"].string,
    _id: _propTypes["default"].string
  }),
  handleChange: _propTypes["default"].func,
  index: _propTypes["default"].number,
  title: _propTypes["default"].string,
  containerElementSelector: _propTypes["default"].string,
  isSelected: _propTypes["default"].bool
};
var _default = exports["default"] = TemplateItem;